import cx from 'clsx';
import { stripEmbeddedEmailEditorDesign } from '@/helpers';
import styles from './MessageEmailPreview.module.sass';

type MessageEmailPreviewProps = {
  content: string;
  className?: string;
};

export const MessageEmailPreview = ({ content, className }: MessageEmailPreviewProps) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      <iframe
        srcDoc={stripEmbeddedEmailEditorDesign({ html: content || '' })}
        scrolling="no"
        className={styles.iframe}
      />
    </div>
  );
};
